import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import toast from "react-hot-toast";

import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { finalizePaymentRequest } from "app/api/payment";
import { BUSHA_ROOT } from "app/constants/routes";
import { useNavigate } from "react-router-dom";

export default function useFinalizeRequest() {
  const navigate = useNavigate();

  const { isLoading, data, mutate, error } = useMutation(finalizePaymentRequest, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;

      if (axios.isAxiosError(error)) {
        const isInvalidAuthentication = error.response?.data.error?.message?.toLowerCase() === "invalid authentication";
        if (error.response?.status === 401 && !isInvalidAuthentication) {
          navigate(BUSHA_ROOT, { replace: true });
        }
      }

      toast.error(errorMessage);
    },
  });

  return { isLoading, data: data?.data?.data, finalizePaymentRequest: mutate, error: error ? parseError(error) as string : null };
}
